// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SorterDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SorterDoubleIcon" ref={forwardedRef} {...props}>
      <path d="m9.996 4 5 5-.005.005H5L4.997 9z" />
      <path d="m9.996 17-5-5 .006-.006h9.988L14.996 12z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SorterDoubleIcon = /* @__PURE__ */ Object.assign(
  SorterDoubleIconComponent,
  { displayName: 'SorterDoubleIcon' },
);
